import React, { useEffect, useRef, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  withStyles,
  Theme,
  createStyles,
  makeStyles,
} from "@material-ui/core/styles";
import Loader from "../../components/Loader2";
import { Grid, TextField, Typography, Chip } from "@material-ui/core";
import Box from "@mui/material/Box";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import {
  getLedgerDetails,
  getCenterInfo,
  getLedgerBalance,
  refundTDS,
  resetBookings,
} from "../../actions/OffLineSupportActions";
import { TablePagination } from "@material-ui/core";
import moment from "moment";
import Button from "@mui/material/Button";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { Dialog } from "@mui/material";
const StyledTableCell: any = withStyles((theme: Theme) =>
  createStyles({
    head: {
      backgroundColor: "#0E3F6C",
      color: theme.palette.common.white,
      fontSize: "14px",
    },
    body: {
      fontSize: 14,
      padding: "5px",
      textTransform: "capitalize",
    },
  })
)(TableCell);

const StyledTableRow: any = withStyles((theme: Theme) =>
  createStyles({
    root: {
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
      },
    },
  })
)(TableRow);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    content: {
      width: "80%",
      flexGrow: 21,
    },
    contentHeader: {
      width: "100%",
      padding: "0px 10px 10px 0px",
    },
    contentFilter: {
      width: "100%",
      padding: "0px 10px 10px 0px",
    },
    contentTable: {
      width: "100%",
      padding: "0px 0px 10px 0px",
      borderLeft: "solid 1px #0e416b",
      borderRight: "solid 1px #0e416b",
      borderBottom: "solid 1px #0e416b",
      marginTop: "20px",
      minHeight: "300px",
    },
    table: {
      minWidth: 700,
    },
    tableRow: {
      padding: "5px 0 5px 5px !important",
    },
    root: {
      flexGrow: 0,
    },
    toolbar: {
      alignItems: "center",
      justifyContent: "flex-end",
      padding: theme.spacing(0, 1),
      ...theme.mixins.toolbar,
    },
    input: {
      padding: "1px",
    },
    tableContainer: {
      marginTop: "1rem",
      position: "sticky",
      top: "200px",
    },
    centerIt: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    paper: {
      marginTop: "1rem",
      padding: "1rem 0.5rem 0.5rem 0.5rem",
      width: "100%",
    },
  })
);

interface Props {
  loading: boolean;
  getLedgerDetails: any;
  clientLedgerDetails: any;
  getLedgerBalance: any;
  clientLedgerBalance: any;
  getCenterInfo: any;
  centerInfo: any;
  refundTDS: any;
  resetBookings:any;
  clientLedgerDetailsLoader:any;
}

const CcLedger: React.FC<Props> = ({
  loading,
  clientLedgerDetails,
  getLedgerDetails,
  getLedgerBalance,
  clientLedgerBalance,
  getCenterInfo,
  centerInfo,
  refundTDS,
  resetBookings,
  clientLedgerDetailsLoader,
}) => {
  const timer = useRef<any>(0);
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [start_date, setStart_date] = useState<any>("");
  const [startDate, setStartDate] = useState<any>("");
  const [end_date, setEnd_date] = useState<any>("");
  const [endDate, setEndDate] = useState<any>("");
  const [center, setCenter] = useState<any>("");
  const [open, setOpen] = useState<boolean>(false);
  const history = useHistory();
  const [centreID, setCentreID] = React.useState<any>("");


  const dispatch = useDispatch();

  
  const filterHandler = () => {
     if(center){
      getLedgerBalance(`center_id=${center}`);
      setStart_date(startDate);
      setEnd_date(endDate);
      setPage(0);
     }
   
  };
  const resetHandler = () => {
     history.push("/dashboard/os/booking-ledger")
     resetBookings()
  }

  const [windowSize, setWindowSize] = useState(getWindowSize());

  useEffect(() => {
    function handleWindowResize() {
      setWindowSize(getWindowSize());
    }

    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);

  function getWindowSize() {
    const { innerWidth, innerHeight } = window;
    return { innerWidth, innerHeight };
  }
  return (
    <main className={classes.content}>
      <div style={{ width: "100%" }}>
        <div className={classes.toolbar} />
        <div className={classes.contentHeader}>
          {windowSize.innerWidth && windowSize.innerWidth ? (
            <h4 style={{ fontWeight: "bold" }} className={classes.centerIt}>
              LEDGER
            </h4>
          ) : (
            <h4 style={{ fontWeight: "bold" }} className={classes.centerIt}>
              COLLECTION CENTER LEDGER
            </h4>
          )}
        </div>
        <div
          className={classes.contentFilter}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={3}>
              <Autocomplete
                id="center"
                onChange={(event, newValue) => {
                  if (newValue) {
                    let obj = JSON.parse(JSON.stringify(newValue, null, " "));
                    setCenter(obj.id);
                  }
                }}
                freeSolo
                blurOnSelect
                options={centerInfo?.results || []}
                disableClearable
                disableCloseOnSelect
                getOptionLabel={(option: any) =>
                  (option?.display_name === null
                    ? option?.name
                    : option?.display_name) +
                  "(" +
                  option?.center_code +
                  ")"
                }
                renderOption={(option) => (
                  <>
                    {(option?.display_name === null
                      ? option?.name
                      : option?.display_name) +
                      "(" +
                      option?.center_code +
                      ")"}
                    {!option?.is_active && (
                      <b style={{ color: "red" }}>(Deactive)</b>
                    )}
                  </>
                )}
                loading={loading}
                onInputChange={(event, newInputValue) => {
                  clearTimeout(timer.current);
                  timer.current = setTimeout(() => {
                    getCenterInfo(
                      `?show_all=true&name_or_code=${newInputValue}`
                    );
                  }, 1000);

                  if (newInputValue.length === 0) {
                    setCenter("");
                  } else if (centerInfo.results === 1) {
                  }
                }}
                
                renderInput={(params) => (
                  <TextField
                    className={classes.input}
                    {...params}
                    placeholder="Centre"
                    variant="outlined"
                    InputProps={{
                        ...params.InputProps,
                        style: {
                          height: 37,
                          
                        }
                      }}
                    
                    fullWidth
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <TextField
                className="input"
                name="start_date"
                type="date"
                label="Start Date"
                value={startDate}
                variant="outlined"
                onChange={(e) => setStartDate(e.target.value)}
                style={{ width: "100%" }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                name="end_date"
                type="date"
                value={endDate}
                className="input"
                label="End Date"
                variant="outlined"
                onChange={(e) => setEndDate(e.target.value as string)}
                style={{ width: "100%" }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={1}>
              <Button
                variant="contained"
                color="secondary"
                fullWidth
                onClick={filterHandler}
              >
                Filter
              </Button>
            </Grid>
            <Grid item xs={12} sm={6} md={1}>
              <Button
                variant="contained"
                color="primary"
                fullWidth
                onClick={resetHandler}
              >
                Reset
              </Button>
            </Grid>
            <Grid item xs={12} sm={6} md={1}>
              <Button
                variant="contained"
                color="secondary"
                fullWidth
                onClick={() =>
                  history.push("/dashboard/ccadmin/cc_Ledger_export")
                }
              >
                Export
              </Button>
            </Grid>
          </Grid>
        </div>
        <TableContainer
          className={classes.tableContainer}
          component={Paper}
          style={{ maxHeight: "700px" }}
        >
          <Table stickyHeader aria-label="simple table">
            {
              clientLedgerBalance.results && <TableHead>
              <StyledTableRow>
                <StyledTableCell align="center">S. NO.</StyledTableCell>
                <StyledTableCell align="center">Centre Name</StyledTableCell>
                <StyledTableCell align="center">Centre Code</StyledTableCell>
                <StyledTableCell align="center">Centre Type</StyledTableCell>
                <StyledTableCell align="center">Status</StyledTableCell>
                <StyledTableCell align="center">Balance</StyledTableCell>

                <StyledTableCell align="center">
                  Total Billing Done
                </StyledTableCell>

                {/* <StyledTableCell align="center">More Details</StyledTableCell> */}
              </StyledTableRow>
            </TableHead>
            }
            <TableBody>
              {clientLedgerBalance.results &&
                clientLedgerBalance.results.length > 0 &&
                clientLedgerBalance.results.map((val: any, index: any) => {
                  return (
                    <Row
                      key={val.centre_id}
                      val={val}
                      index={index}
                      open={open}
                      setOpen={setOpen}
                      centreID={centreID}
                      setCentreID={setCentreID}
                      clientLedgerDetails={clientLedgerDetails}
                      getLedgerDetails={getLedgerDetails}
                      loading={loading}
                      clientLedgerDetailsLoader={clientLedgerDetailsLoader}
                      start_date={start_date}
                      end_date={end_date}
                      refundTDS={refundTDS}
                    />
                  );
                })}
            </TableBody>
            
          </Table>
        </TableContainer>
      </div>
    </main>
  );
};

function Row(props: {
  val: any;
  index: any;
  centreID: any;
  setCentreID: any;
  open: any;
  setOpen: any;
  getLedgerDetails: any;
  clientLedgerDetails: any;
  start_date: any;
  end_date: any;
  loading: boolean;
  refundTDS: any;
  clientLedgerDetailsLoader: boolean;
}) {
  const {
    val,
    centreID,
    setCentreID,
    clientLedgerDetails,
    index,
    getLedgerDetails,
    open,
    setOpen,
    start_date,
    end_date,
    loading,
    refundTDS,
    clientLedgerDetailsLoader,
  } = props;

  useEffect(()=> {
    getLedgerDetails(
      `center=${val.centre_id}&start_date=${start_date}&end_date=${end_date}`
    );
  },[])
  const [refundData, setRefundData] = useState<any>("");

  // const setOpenTest = (centreId: number) => {
  //   getLedgerDetails(
  //     `center=${centreId}&start_date=${start_date}&end_date=${end_date}`
  //   );
  //   setOpen(open);
  //   setCentreID(centreId);
  // };
  const handleDOBForAge = (dob: any, bdate: any) => {
    const a: any = moment(bdate);
    const b: any = moment(dob);
    var years = a.diff(b, "year");
    b.add(years, "years");
    var months = a.diff(b, "months");
    b.add(months, "months");
    var days = a.diff(b, "days");
    if (months !== 0) {
      var age = months + "Months " + days + "Days";
    } else {
      var age = days + "Days";
    }

    return age;
  };
  const classes = useStyles();
  const [printData, setPrintData] = useState<any>([]);
  const [testArray, setTestArray] = useState<any>([]);
  const [page, setPage] = useState(0);
  const history = useHistory();
  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    if (newPage > page) {
      let url =
        clientLedgerDetails.links &&
        clientLedgerDetails.links.next.split("?")[1];
      getLedgerDetails(url);
    } else if (newPage < page) {
      let url =
        clientLedgerDetails.links &&
        clientLedgerDetails.links.previous.split("?")[1];
      getLedgerDetails(url);
    }
    setPage(newPage as number);
  };
  const refund = async () => {
    await refundTDS({ ledgerids: String(refundData?.id) });
    setRefundData("")
    getLedgerDetails(
      `center=${val.centre_id}&start_date=${start_date}&end_date=${end_date}`
    );
  };
  return (
    <>
      <StyledTableRow key={val.centre_id} className={classes.tableRow}>
        <StyledTableCell align="center">{index + 1}</StyledTableCell>
        <StyledTableCell align="center">
          {val?.display_name === null ? val?.centre_name : val?.display_name}
        </StyledTableCell>
        <StyledTableCell align="center">{val.code}</StyledTableCell>
        <StyledTableCell align="center">{val.type}</StyledTableCell>
        <StyledTableCell align="center">{val.pre_post}</StyledTableCell>
        <StyledTableCell align="center">
          {Math.round(val.balance).toFixed(2)}
        </StyledTableCell>

        <StyledTableCell align="center">{val.billed_amount}</StyledTableCell>

        {/* <StyledTableCell align="center">
          {" "}
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpenTest(val.centre_id)}
            style={{ background: "rgb(63 81 181 / 43%)" }}
          >
            {centreID == val.centre_id ? (
              <KeyboardArrowUpIcon />
            ) : (
              <KeyboardArrowDownIcon />
            )}
          </IconButton>
        </StyledTableCell> */}
      </StyledTableRow>
      <StyledTableRow>
        <StyledTableCell
          style={{ paddingBottom: 0, paddingTop: 0 }}
          colSpan={10}
        >
         
            <Box margin={1}>
              <Grid container xs={12}>
                <Grid item xs={11}>
                  <Typography variant="h6" gutterBottom component="div">
                    All Transaction Details
                  </Typography>
                </Grid>
                <Grid item xs={1} style={{ textAlign: "right" }}></Grid>
              </Grid>
              <TableContainer style={{ maxHeight: 350 }}>
                {clientLedgerDetailsLoader ? (
                   <Loader/>
                ) : (
                  <Table size="small" aria-label="purchases" stickyHeader>
                    <TableHead>
                      <StyledTableRow>
                        <StyledTableCell align="center">
                          <b>Sr. No.</b>
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <b>Bill No.</b>
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <b>Payment Date & Time</b>
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <b>Patient Name</b>
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <b>Age</b>
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <b>Gender</b>
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <b>Test Code</b>
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <b>Test Name</b>
                        </StyledTableCell>

                        <StyledTableCell align="center">
                          <b>Is Coupon</b>
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <b>Gross</b>
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <b>Discount Amt.</b>
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <b>Discount From</b>
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <b>Client Share(%)</b>
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <b>Client Share</b>
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <b>Credit/Debit</b>
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <b>RCL Share</b>
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <b>TDS Amount</b>
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <b>Refund TDS</b>
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <b>Balance</b>
                        </StyledTableCell>

                        <StyledTableCell align="center">
                          <b>Amount added by</b>
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <b>Remarks</b>
                        </StyledTableCell>
                      </StyledTableRow>
                    </TableHead>
                    <TableBody>
                      {clientLedgerDetails.results &&
                        clientLedgerDetails.results.length > 0 &&
                        clientLedgerDetails.results.map(
                          (qual: any, index: any) => {
                            return (
                              <StyledTableRow>
                                <StyledTableCell align="center">
                                  {index + 1}
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                  {qual?.booking}
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                  {moment(qual?.created_at).format(
                                    "DD-MM-YYYY, HH:mm"
                                  )}
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                  {qual.customer_name}
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                  {qual?.customer_age === 0
                                    ? handleDOBForAge(
                                        qual?.dob,
                                        qual?.booking_date
                                      )
                                    : qual?.customer_age}
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                  {qual.customer_gender}
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                  {qual.package_code}
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                  {qual.package_name}
                                </StyledTableCell>

                                <StyledTableCell align="center">
                                  {qual.camp_coupon}
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                  {qual.amount}
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                  {qual.discount_amount}
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                  {qual.discount_from}
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                  {qual?.client_discount_percentage
                                    ? qual?.client_discount_percentage
                                    : "0"}
                                  %
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                  {Number(qual.client_share).toFixed(2)}
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                  {qual?.ledger_type == "credit" ? (
                                    <Chip
                                      size="small"
                                      label="Credit"
                                      style={{
                                        backgroundColor: "#4caf50",
                                        color: "#fff",
                                      }}
                                    />
                                  ) : (
                                    <Chip
                                      size="small"
                                      label="Debit"
                                      style={{
                                        backgroundColor: "#f44336",
                                        color: "#fff",
                                      }}
                                    />
                                  )}
                                </StyledTableCell>

                                <StyledTableCell align="center">
                                  {Number(qual?.rcl_share).toFixed(2)}
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                  {Number(qual?.tds_amount).toFixed(2)}
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                  <Button
                                    variant="contained"
                                    size="small"
                                    color="warning"
                                    onClick={() => setRefundData(qual)}
                                    disabled={
                                      qual?.bill_id !== null &&
                                      qual?.type_subtype?.tds_refund === true &&
                                      qual?.status !== "tds" &&
                                      qual?.status !== "tds_refunded"
                                        ? false
                                        : true
                                    }
                                  >
                                    refund
                                  </Button>
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                  {Number(qual?.center_rem_balance).toFixed(2)}
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                  {qual?.by_user}
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                  <sub>{qual?.remarks}</sub>
                                </StyledTableCell>
                              </StyledTableRow>
                            );
                          }
                        )}
                    </TableBody>
                    <TablePagination
                      rowsPerPageOptions={[]}
                      colSpan={3}
                      count={clientLedgerDetails.count || 0}
                      rowsPerPage={clientLedgerDetails.page_size || 0 }
                      page={page}
                      onPageChange={handleChangePage}
                    />
                  </Table>
                )}
              </TableContainer>
            </Box>
         
        </StyledTableCell>
      </StyledTableRow>
      <Dialog
        open={refundData?.id ? true : false}
        onClose={() => setRefundData("")}
      >
        <div style={{ padding: 20 }}>
          <h5>
            Are you sure want to refund the TDS Amount of{" "}
            {refundData?.tds_amount}?
          </h5>
          <br />
          <Button
            variant="contained"
            color="success"
            disabled={loading}
            onClick={() => refund()}
          >
            Confirm Refund
          </Button>
          <Button
            style={{ marginLeft: "10px" }}
            variant="contained"
            color="error"
            onClick={() => {
              setRefundData("");
            }}
          >
            Close
          </Button>
        </div>
      </Dialog>
    </>
  );
}
const mapStateToProps = (state: any) => ({
  clientLedgerDetails: state.OffLineSupporteReducer.clientLedgerDetails,
  clientLedgerBalance: state.OffLineSupporteReducer.clientLedgerBalance,
  centerInfo: state.OffLineSupporteReducer.centerInfo,
  loading: state.OffLineSupporteReducer.loading,
  clientLedgerDetailsLoader: state.OffLineSupporteReducer.clientLedgerDetailsLoader,
});
export default connect(mapStateToProps, {
  getLedgerDetails,
  getCenterInfo,
  getLedgerBalance,
  refundTDS,
  resetBookings,
})(CcLedger);
